import useTranslate from '../../i18n/useTranslate'
const useLookupClient = () => {
    const translate = useTranslate()
    const getYesNo = () => {
        return [
            {
                id: '1',
                name: translate.get('LABEL.NO'),
            },
            {
                id: '2',
                name: translate.get('LABEL.YES'),
            },
        ]
    }

    const getRequest = () => {
        return [
            {
                id: '1',
                name: translate.get('LABEL.NEED'),
            },
            {
                id: '2',
                name: translate.get('LABEL.NOT_NEED'),
            },
        ]
    }

    const getIRB = () => {
        return [
            { label: 'REC 1', value: '1' },
            { label: 'REC 2', value: '2' },
        ]
    }

    const getDocumentResult = () => {
        return [
            {
                id: '1',
                name: translate.get('LABEL.DOC_COMPLETED'),
            },
            {
                id: '2',
                name: translate.get('LABEL.DOC_INCOMPLETE'),
            },
        ]
    }

    const getNeedDoc = () => {
        return [
            {
                value: '1',
                label: translate.get('LABEL.NEED'),
            },
            {
                value: '0',
                label: translate.get('LABEL.NOT_NEED'),
            },
        ]
    }

    const getGroupsUser = () => {
        return [
            {
                id: '1',
                name: translate.get('LABEL.PRESIDENT'),
            },
            {
                id: '2',
                name: translate.get('LABEL.SECRETARY'),
            },
        ]
    }

    return { getYesNo, getRequest, getIRB, getDocumentResult, getNeedDoc, getGroupsUser }
}

export default useLookupClient
